import { render, staticRenderFns } from "./TheVideoPlayerContainer.vue?vue&type=template&id=6c134587&scoped=true&lang=html&"
import script from "./TheVideoPlayerContainer.vue?vue&type=script&lang=ts&"
export * from "./TheVideoPlayerContainer.vue?vue&type=script&lang=ts&"
import style0 from "./TheVideoPlayerContainer.vue?vue&type=style&index=0&id=6c134587&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c134587",
  null
  
)

export default component.exports